import { DateHelper } from '@bryntum/grid';
import { FormatString } from '../constant/format-string';

export class DateTimeHelper {
  /**
   * Converts a UTC date to local time by adjusting for the timezone offset.
   *
   * @param utcDate - The UTC date to convert to local time
   * @returns A new Date object representing the same moment in local time
   */
  static utcToLocal(utcDate: Date): Date {
    if(typeof utcDate === 'string') {
      utcDate = new Date(utcDate);
    }

    const utcTime = utcDate.getTime();
    const timezoneOffset = utcDate.getTimezoneOffset() * 60000; // Convert minutes to milliseconds
    return new Date(utcTime - timezoneOffset);
  }

  static parseBryntumDate(value: string | Date | null | undefined): Date | null {
    return this.parseBryntumValue(value, FormatString.bryntumDate);
  }

  static parseBryntumTime(value: string | Date | null | undefined): Date | null {
    return this.parseBryntumValue(value, FormatString.bryntumTime24h);
  }

  private static parseBryntumValue(value: string | Date | null | undefined, format: string): Date | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (value instanceof Date) {
      return Number.isNaN(value.getTime()) ? null : value;
    }

    const parsedValue = DateHelper.parse(value, format);
    if (!parsedValue) {
      return null;
    }

    if (Number.isNaN(parsedValue.getTime())) {
      return null;
    }

    return parsedValue;
  }

}
